// @context TGW-1860 リアクション用の絵文字一覧（＋ボタンから開く全絵文字ピッカー）。
//   OS 標準の絵文字（Unicode）をカテゴリ別に持つだけのデータ。BE は任意の絵文字（1書記素）を
//   許可するため、ここから選んだ絵文字はそのまま like_type として保存される。
export const DEFAULT_LIKE_TYPES = ['♥️', '😄', '🙁', '😢', '👍'];

export const EMOJI_CATEGORIES = [
  {
    label: 'よく使う',
    emojis: ['👍', '❤️', '😄', '🎉', '🙏', '😢', '🙁', '😮', '🔥', '👏', '✅', '💯'],
  },
  {
    label: 'スマイル',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '🥲', '😊', '😇', '🙂',
      '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝',
      '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🥳', '🤩', '😏', '😒', '😞', '😔',
      '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤',
      '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓',
      '🤗', '🤔', '🫡', '🤭', '🤫', '😶', '😐', '😑', '😬', '🙄', '😮', '😲',
      '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒',
      '🤕', '🥸', '🤠', '😈', '👿', '💀', '👻', '👽', '🤖', '💩',
    ],
  },
  {
    label: 'ジェスチャー',
    emojis: [
      '👍', '👎', '👌', '🤌', '🤏', '✌️', '🤞', '🫰', '🤟', '🤘', '🤙', '👈',
      '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤝', '🙏', '✊',
      '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '💪', '🙇', '🙅', '🙆', '🙋',
      '🤦', '🤷', '💁', '🫶',
    ],
  },
  {
    label: 'ハート・記号',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕',
      '💞', '💓', '💗', '💖', '💘', '💝', '💯', '💢', '💥', '💫', '⭐', '🌟',
      '✨', '⚡', '🔥', '🎉', '🎊', '🎈', '🎁', '✅', '❌', '⭕', '‼️', '❓',
      '❗', '💤', '🆗',
    ],
  },
  {
    label: '動物・自然',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮',
      '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🦄', '🐝', '🦋', '🐢', '🐙',
      '🐳', '🐬', '🐟', '🌸', '🌺', '🌻', '🌹', '🌷', '🌈', '☀️', '🌙', '☁️',
    ],
  },
  {
    label: '食べ物',
    emojis: [
      '🍎', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍑', '🍒', '🍔', '🍟', '🍕',
      '🌭', '🍿', '🍩', '🍪', '🎂', '🍰', '🍫', '🍬', '🍭', '🍦', '☕', '🍺',
      '🍻', '🥂', '🍷', '🍶', '🍜', '🍣', '🍙', '🍚',
    ],
  },
  {
    label: 'アクティビティ・物',
    emojis: [
      '⚽', '🏀', '🎾', '🎮', '🎯', '🎸', '🎤', '🎧', '🎬', '📷', '💻', '📱',
      '💡', '🔑', '🏆', '🥇', '🎓', '📚', '✏️', '💰', '🕐', '⏰', '📌', '🎵',
    ],
  },
];
